import appConfig from '../../../config/appConfig';

var vendorConfig = {
  apiUrl: appConfig.apiUrl + 'vendors/',
  vendorsFastSearchUrl:  appConfig.apiUrl + 'vendors/fastsearch/',
};

export default vendorConfig;



// WEBPACK FOOTER //
// ./src/components/vendors/config/vendorConfig.js